import React from 'react'
import PathogenMain from '../components/pathogen-testing/PathogenMain'
import PathogenTests from '../components/pathogen-testing/PathogenTests'
import PathogenTesting from '../components/pathogen-testing/PathogenTesting'
import PathogenRequired from '../components/pathogen-testing/PathogenRequired'
import PathogenInfection from '../components/pathogen-testing/PathogenInfection'
import PathogenWeeklyRates from '../components/pathogen-testing/PathogenWeeklyRates'
import PathogenSymptoms from '../components/pathogen-testing/PathogenSymptoms'
import PathogenTraditionalDiagnostics from '../components/pathogen-testing/PathogenTraditionalDiagnostics'
import PathogenSyndromicTesting from '../components/pathogen-testing/PathogenSyndromicTesting'
import PathogenOverall from '../components/pathogen-testing/PathogenOverall'
import PathogenComparison from '../components/pathogen-testing/PathogenComparison'
import PathogenContactInfo from '../components/pathogen-testing/PathogenContactInfo'
import PathogenEasyAccess from '../components/pathogen-testing/PathogenEasyAccess'
import PathogenServicesChicago from '../components/pathogen-testing/PathogenServicesChicago'
import MainHeader from '../layout/MainHeader'
import MainResHeader from '../layout/MainResHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const PathogenPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>

    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Respiratory Pathogen Panel Testing in Chicago in Chicago IL | United Lab Care</title>
      <meta name="description" content="Worried about respiratory infections? Get tested with our comprehensive respiratory pathogen panel in Chicago with accurate results." />
	<link rel="canonical" href="https://unitedlabcare.com/respiratory-pathogen-panel-testing-in-chicago/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Respiratory Pathogen Panel Testing in Chicago in Chicago IL | United Lab Care" />
	<meta property="og:description" content="Worried about respiratory infections? Get tested with our comprehensive respiratory pathogen panel in Chicago with accurate results." />
	<meta property="og:url" content="https://unitedlabcare.com/respiratory-pathogen-panel-testing-in-chicago/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-08-10T19:00:38+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2022/12/RPP-Testing-icon1.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="11 minutes" />
      </Helmet>
    </HelmetProvider>
    
        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <PathogenMain/>
        <PathogenTests/>
        <PathogenTesting/>
        <PathogenRequired/>
        <PathogenInfection/>
        <PathogenWeeklyRates/>
        <PathogenSymptoms/>
        <PathogenTraditionalDiagnostics/>
        <PathogenSyndromicTesting/>
        <PathogenOverall/>
        <PathogenComparison/>
        <PathogenContactInfo/>
        <PathogenEasyAccess/>
        <PathogenServicesChicago/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default PathogenPage